import { AUTH_TOKEN_KEY } from "../constants"

export default () => ({ Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY) })
